import { Box, Icon, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import image1 from '../assets/full.png'
import image2 from '../assets/imageWPFA.png'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'

const PersonalityInfoModal = ({ variant }) => {
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '100%',
    bgcolor: 'white.main',
    boxShadow: 24,
    borderRadius: '4.5px',
  }
  return (
    <>
      {variant === 'card' && (
        <Icon onClick={handleOpen} sx={{ color: 'information.main', cursor: 'pointer' }}>
          info
        </Icon>
      )}
      {variant === 'module' && (
        <Typography
          variant="body1"
          sx={{ color: 'alternate.main', cursor: 'pointer', width: '80px' }}
          onClick={handleOpen}
        >
          Learn more
        </Typography>
      )}
      <AdxFormModal
        open={open}
        handleClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        title={'About Work Personality'}
        icon={<Icon>information</Icon>}
        iconColor="information.main"
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box
            sx={{
              height: '250px',
              width: '100%',
              background: 'linear-gradient(97deg, #D5FFFD 27.67%, #81D0D0 100.22%)',
              position: 'relative',
              borderRadius: '4.5px',
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
              }}
              component="img"
              alt=""
              src={variant === 'card' ? image1 : image2}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
              alignItems: 'start',
              gap: 2,
            }}
          >
            <Typography variant="subtitle1" fontWeight={600}>
              {variant === 'card' ? 'Work Personality' : '  Work Personality Fit'}
            </Typography>
            <Typography variant="body1" align="left">
              {variant === 'card'
                ? 'Our work personality test is crafted to'
                : 'Our Work Personality Fit is designed to provide in-depth insights into three critical areas:'}
              <br />
              <br />
              {variant === 'card'
                ? 'a) Elevate your hiring strategy'
                : 'a) Employee-focused comparison'}
              <br />
              {variant === 'card'
                ? "Gain a deep understanding of candidate's suitability for diverse job types and work environments. Uncover the key to identifying the perfect match for your team"
                : "Discover how each individual's personality traits either align with or diversify the existing staff's characteristics. This analysis aids in forging well-rounded, complementary teams that thrive on both unity and diversity."}
              <br />
              <br />
              {variant === 'card' ? 'b) Tailored team dynamics' : 'b) Employee department fit'}
              <br />
              {variant === 'card'
                ? 'Receive a detailed yet concise snapshot of how each candidate seamlessly aligns with your organization, particularly within specific departments.'
                : 'Evaluate the compatibility of staff members within their specific departments to ensure optimal team dynamics. This assessment not only enhances productivity but also contributes to higher job satisfaction and engagement.'}
              <br />
              <br />
              {variant === 'card'
                ? 'c) Benchmark for success'
                : 'c) Department personality comparison'}
              <br />
              {variant === 'card'
                ? 'Offer employers benchmarking capabilities by comparing candidates with existing staff or department personality traits.'
                : 'Obtain a holistic view of the personality landscape across departments. These insights enable you to tailor talent management strategies, fostering a culture of productivity and seamless collaboration throughout the organization.'}
            </Typography>
          </Box>
          {variant === 'card' && (
            <>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  alignItems: 'start',
                  gap: 2,
                }}
              >
                <Typography variant="subtitle1" fontWeight={600}>
                  Candidate vs Department Average
                </Typography>
                <Typography variant="body1" align="left">
                  Gain detailed insights into candidates' alignment with departmental traits, aiding
                  employers in decision-making. Choose candidates who align closely or bring fresh
                  perspectives.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  alignItems: 'start',
                  gap: 2,
                }}
              >
                <Typography variant="subtitle1" fontWeight={600}>
                  Candidate vs Staff
                </Typography>
                <Typography variant="body1" align="left">
                  Assess candidates' compatibility with existing team traits. Use this benchmark to
                  make informed decisions, whether seeking alignment or diversity within the team.
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </AdxFormModal>
    </>
  )
}

export default PersonalityInfoModal
